import { useSale } from '../../../../hooks/sale/useSale';

import POSDateField from '../../../POS/Fields/POSDateField';
import POSInputField from '../../../POS/Fields/POSInputField';

const POSCreditYearsSection = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { form, updateField } = useSale();

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      className="
        mt-4

        rounded-lg
        border
        border-stroke

        bg-whiten

        p-4

        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Content */}
      {/* ===================================================== */}
      <div className="space-y-4">
        {/* ===================================================== */}
        {/* 🔹 Due Date */}
        {/* ===================================================== */}
        <POSDateField
          name="paymentCondition.creditDueDate"
          label="Fecha límite"
          iconKey="calendar"
          value={form.paymentCondition?.creditDueDate || ''}
          disabled
          onChange={() => {}}
        />

        {/* ===================================================== */}
        {/* 🔹 Credit Years */}
        {/* ===================================================== */}
        <POSInputField
          name="paymentCondition.creditYears"
          label="Años de crédito"
          type="number"
          min={0}
          placeholder="Ej: 1"
          icon="calendar"
          value={form.paymentCondition?.creditYears ?? ''}
          onChange={(e) => {
            const value = e.target.value.trim();

            if (value === '') {
              updateField('paymentCondition', {
                ...form.paymentCondition,

                creditYears: undefined,

                creditDueDate: '',
              });

              return;
            }

            const years = Number(value);

            if (form.saleDate && !isNaN(years)) {
              const start = new Date(form.saleDate);

              const dueDate = new Date(start);

              dueDate.setFullYear(start.getFullYear() + years);

              updateField('paymentCondition', {
                ...form.paymentCondition,

                creditYears: years,

                creditDueDate: dueDate.toISOString().split('T')[0],
              });
            }
          }}
        />
      </div>
    </div>
  );
};

export default POSCreditYearsSection;
